module.exports = __webpack_public_path__ + "static/img/device-small.a0b90f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/GreenIQ/device-small.png
// module id = gu0g
// module chunks = 0